<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-domicanasta main-bg">
      <a class="navbar-brand" href="#">
        <div class="milogo">
          <img src="../../assets/logo_blue_2.png" class="mr-2" />
          <span id="app-version">v{{ version }}</span>
        </div>
      </a>
      <a href="" @click.prevent="toggleMenu" id="show-menu-toggle">
        <i v-if="snowMenu" class="fa fa-close text-white"></i>
        <i v-else class="fa fa-bars text-white"></i>
      </a>

      <div class="container-fluid">
        <div
          class="collapse navbar-collapse justify-content-end"
          id="navigation"
        >
          <ul class="navbar-nav">
            <li class="nav-item btn-rotate dropdown">
              <a
                class="nav-link dropdown-toggle text-white"
                href="#"
                style="text-transform: none; font-weight: bold"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span v-if="$store.getters.getCompanyPhoto != ''">
                  <img
                    :src="$store.getters.getCompanyPhoto"
                    alt="Foto usuario"
                    class="photo"
                  />
                  {{ $store.getters.userName }}
                </span>
                <span v-else>
                  <i class="fa fa-user-circle mr-1"></i>
                  {{ $store.getters.userName }}
                </span>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <a @click="logout()" class="dropdown-item" href="#">
                  <i class="fa fa-sign-out"></i>&nbsp;Salir
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div
      class="sidebar"
      data-color="white"
      data-active-color="danger"
      style="top: 0"
    >
      <!-- Sidebar (Menus) -->
      <div class="sidebar-wrapper">
        <ul v-if="$userIsAdmin()" class="nav">
          <!-- <li :class="$route.name == 'orders' ? 'active' : ''">
            <router-link to="/orders">
              <p>Ordenes</p>
            </router-link>
          </li> -->
          <li :class="$route.name == 'companies' ? 'active' : ''">
            <router-link to="/companies">
              <p>Sucursales</p>
            </router-link>
          </li>
          <li :class="$route.name == 'services' ? 'active' : ''">
            <router-link to="/services">
              <p>Servicios</p>
            </router-link>
          </li>
          <li :class="$route.name == 'advertising' ? 'active' : ''">
            <router-link to="/advertising">
              <p>Publicidades</p>
            </router-link>
          </li>
          <li :class="$route.name == 'GiftCardApplication' ? 'active' : ''">
            <router-link to="/GiftCardApplication">
              <p>Solicitud de bonos</p>
            </router-link>
          </li>
          <li :class="$route.name == 'analytics' ? 'active' : ''">
            <router-link to="/analytics">
              <p>Graficas Analiticas</p>
            </router-link>
          </li>
          <li :class="$route.name == 'tableAnalytics' ? 'active' : ''">
            <router-link to="/tableAnalytics">
              <p>Tabla Analiticas</p>
            </router-link>
          </li>
          <!-- <li :class="$route.name == 'banners' ? 'active' : ''">
            <router-link to="/banners">
              <p>Publicidad</p>
            </router-link>
          </li> -->
          <!-- <li :class="$route.name == 'configurations' ? 'active' : ''">
            <router-link to="/configurations">
              <p>Configuración</p>
            </router-link>
          </li> -->
          <!-- <li :class="$route.name == 'availability-zones' ? 'active' : ''">
            <router-link to="/availability-zones">
              <p>Zonas</p>
            </router-link>
          </li> -->
          <!-- <li :class="$route.name == 'coupons' ? 'active' : ''">
            <router-link to="/coupons">
              <p>Cupones</p>
            </router-link>
          </li> -->
          <!-- <li :class="$route.name == 'orders-report' ? 'active' : ''">
            <router-link to="/orders-report">
              <p>Reportes</p>
            </router-link>
          </li> -->
          <li :class="$route.name == 'orders-admin' ? 'active' : ''">
            <router-link to="/reportAdmin">
              <p>Reportes</p>
            </router-link>
          </li>
          <li :class="$route.name == 'admin-users' ? 'active' : ''">
            <router-link to="/admin-users">
              <p>Usuarios del admin</p>
            </router-link>
          </li>
          <li :class="$route.name == 'app-users' ? 'active' : ''">
            <router-link to="/app-users">
              <p>Usuarios del APP</p>
            </router-link>
          </li>
          <!-- <li :class="$route.name == 'lo-primo' ? 'active' : ''">
            <router-link to="/lo-primo">
              <p>Lo' Primo</p>
            </router-link>
          </li> -->
          <!-- <li :class="$route.name == 'onboarding' ? 'active' : ''">
            <router-link to="/onboarding">
              <p>OnBoarding</p>
            </router-link>
          </li> -->
          <li :class="$route.name == 'giftcards' ? 'active' : ''">
            <router-link to="/giftcards">
              <p>Bonos</p>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="$store.getters.isComerce" class="nav">
          <!-- <li :class="$route.name=='orders'?'active':''">
            <router-link to="/orders">
              <p>Ordenes</p>
            </router-link>
          </li>
          <li :class="$route.name=='companies'?'active':''">
            <router-link to="/companies">
              <p>Sucursales</p>
            </router-link>
          </li> -->
          <li :class="$route.name == 'report' ? 'active' : ''">
            <router-link to="/report">
              <p>Reportes</p>
            </router-link>
          </li>
          <li :class="$route.name == 'giftcards' ? 'active' : ''">
            <router-link to="/giftcards">
              <p>Bonos</p>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="$store.getters.isDelivery" class="nav">
          <li :class="$route.name == 'orders' ? 'active' : ''">
            <router-link to="/orders">
              <p>Ordenes</p>
            </router-link>
          </li>
        </ul>

        <!-- <ChartBox label="Ordenes" value="55" /> -->
      </div>
      <!-- End Sidebar -->
    </div>

    <!-- Main content -->
    <div class="main-panel">
      <div class="content" style="padding: 0 !important">
        <transition name="fade1" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import ChartBox from "../components/ChartBox";

export default {
  name: "Navbar",
  components: { ChartBox },
  data: function () {
    return {
      user: "USUARIO 1",
      companyPhoto: "",
      company: this.$store.getters.getCompany,
      snowMenu: false,
    };
  },

  methods: {
    toggleMenu() {
      this.snowMenu = !this.snowMenu;
      if (!this.snowMenu) {
        document.querySelector(".sidebar").style.transform = "";
      } else {
        document.querySelector(".sidebar").style.transform =
          "translate3d(0, 0, 0)";
      }
    },
    logout: function () {
      firebase.auth().signOut();
      window.location.reload(true);
    },
  },
  computed: {
    version() {
      return require("../../../package.json").version;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/colors";
#show-menu-toggle {
  display: none;
  font-size: 20px;
  margin-right: 10px;
}

li a {
  font-size: 10px;
}
.photo {
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  width: 50px;
}
.select-company {
  font-size: 21px;
  font-weight: bold;
}
.sidebar-wrapper p {
  text-transform: capitalize !important;
  font-weight: bold;
}
.milogo {
  display: flex;
  align-items: baseline;
  height: 50px;
  width: auto;
  img {
    height: inherit;
    widows: inherit;
  }
}
#app-version {
  font-weight: 500;
  font-size: 0.7rem;
  margin-left: 5px;
  text-transform: none !important;
  letter-spacing: 1px;
}
.bg-domicanasta {
  margin-bottom: 0 !important;
  height: 67px !important;
  padding: 0 10px !important;
}

.fade1-enter-active,
.fade1-leave-active {
  transition-duration: 300ms !important;
  transition-property: opacity !important;
  transition-timing-function: ease !important;
}

.fade1-enter,
.fade1-leave-active {
  opacity: 0 !important;
}
.nav p {
  text-transform: none !important;
}
</style>
